export const NAV_STATE_LS_KEY = 'nav-platform-sidebar-state';
